import { groupByHint, isGroupByRecommended } from "../../../logic/services/reportBuilderSummary.js";
import { rbSectionHint } from "../reportBuilderTheme.js";

function FieldList({ title, fields, emptyText, onFieldClick, selectedSet, c, A, actionLabel }) {
  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${c.divider}`,
        borderRadius: 10,
        overflow: "hidden",
        background: c.card,
      }}
    >
      <div style={{ padding: "10px 12px", borderBottom: `1px solid ${c.divider}`, background: c.hover }}>
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: c.sub }}>{title}</span>
      </div>
      <div style={{ flex: 1, overflow: "auto", padding: 8, display: "flex", flexDirection: "column", gap: 4, minHeight: 120 }}>
        {fields.length === 0 ? (
          <p style={{ margin: 0, fontSize: 12, color: c.sub, padding: 8 }}>{emptyText}</p>
        ) : (
          fields.map((field) => {
            const selected = selectedSet.has(field);
            return (
              <button
                key={field}
                type="button"
                onClick={() => onFieldClick(field)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px 10px",
                  borderRadius: 8,
                  border: `1px solid ${selected ? A : "transparent"}`,
                  background: selected ? `${A}12` : "transparent",
                  color: c.text,
                  fontSize: 12,
                  fontWeight: 600,
                  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onMouseEnter={(e) => {
                  if (!selected) e.currentTarget.style.background = c.hover;
                }}
                onMouseLeave={(e) => {
                  if (!selected) e.currentTarget.style.background = selected ? `${A}12` : "transparent";
                }}
              >
                {field}
                <span style={{ fontSize: 10, color: c.sub, fontWeight: 600, fontFamily: "inherit" }}>{actionLabel}</span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}

export function GroupingStep({ fields, groupBy, metricsCount, onToggle, c, A }) {
  const available = fields.filter((f) => !groupBy.includes(f));
  const selectedSet = new Set(groupBy);
  const config = { groupBy, metrics: Array(metricsCount).fill({}) };
  const recommended = isGroupByRecommended(config);
  const hint = groupByHint(config);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: recommended ? A : c.sub,
            background: recommended ? `${A}14` : c.hover,
            padding: "4px 8px",
            borderRadius: 6,
          }}
        >
          {recommended ? "Recommended" : "Optional"}
        </span>
        <p style={{ ...rbSectionHint(c), margin: 0, flex: 1 }}>{hint}</p>
      </div>

      <div style={{ display: "flex", gap: 12, minHeight: 200 }}>
        <FieldList
          title="Available fields"
          fields={available}
          emptyText="All fields are grouped"
          onFieldClick={onToggle}
          selectedSet={new Set()}
          c={c}
          A={A}
          actionLabel="Add →"
        />
        <FieldList
          title="Group by"
          fields={groupBy}
          emptyText="No dimensions — metrics will aggregate globally"
          onFieldClick={onToggle}
          selectedSet={selectedSet}
          c={c}
          A={A}
          actionLabel="Remove"
        />
      </div>
    </div>
  );
}
